import { IdPersistence } from "../constants/IdPersistence";
import { PersistenceMode } from "./PersistenceMode";
import { utilPersistence } from "./utilPersistence";
var UtilBlog = /** @class */ (function () {
    function UtilBlog() {
        var _this = this;
        this.getVersion = function () { return _this.getBlogVersion().version; };
        this.getBlogVersion = function () {
            return utilPersistence.getValue(IdPersistence.BlogVersion, {
                version: 0,
            });
        };
        this.setBlogVersion = function (version) {
            if (version === void 0) { version = 0; }
            utilPersistence.setValue(IdPersistence.BlogVersion, {
                version: version,
            }, PersistenceMode.Write);
        };
    }
    return UtilBlog;
}());
export var utilBlog = new UtilBlog();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilBlog.ts
// module id = 432
// module chunks = 3